import { UserSuggestionList } from "./userSuggestionList";
import { UserSuggestionShow } from "./userSuggestionShow";

export default {
	list: UserSuggestionList,
	show: UserSuggestionShow,
};
